/*
  This is your main file- code goes here
*/
import { hexToRGBA, isValidHex } from './hex';
import { convertRGBToXYZ, convertXYZToLAB, distance } from './lab';
import { getRBGFromString, isValidRGB } from './rgb';
import colors from './colors.json';
import { getTranslationMap } from './i18n';
import galleryPaletteColors from './galleryPaletteColors.json';
/**
 * This accept hex or rgb value return the closest color as culture provided default will 'en-us'.
 * @example
 * import { i18nColorName } from '@design-stack-vista/i18n-color-name';
 *
 * const name = i18nColorName('#808080', { culture: 'en-ie' });
 * // gray
 * @param {string} code rgb or hex code value
 * @param {object} options options provide to find color name
 * @returns {string} color name
 */
export const i18nColorName = (code, options = { culture: 'en-us', colorPalette: 'default' }) => {
    let inputRGB = null;
    if (isValidHex(code)) {
        inputRGB = hexToRGBA(code);
    }
    else if (isValidRGB(code)) {
        inputRGB = getRBGFromString(code);
    }
    if (!inputRGB) {
        throw new Error('unknown color code.');
    }
    const { r, g, b } = inputRGB;
    const [x, y, z] = convertRGBToXYZ(Number(r), Number(g), Number(b));
    const lab = convertXYZToLAB(x, y, z);
    const color = findClosestColor(lab, options.colorPalette);
    const culture = options.culture.toLowerCase();
    const result = getTranslationMap(culture)[color.id];
    return result;
};
/**
 * This method used internally to find the closest distance color provided and against color defined in package.
 * @param l1
 * @returns
 */
export const findClosestColor = (l1, palette = 'default') => {
    const colorList = palette === 'gallery' ? galleryPaletteColors : colors;
    let shortestDistanceColor = colorList[0];
    for (const color of colorList) {
        color.distance = distance(l1, color.lab);
        if (shortestDistanceColor.distance && color.distance < shortestDistanceColor.distance) {
            shortestDistanceColor = color;
        }
    }
    return shortestDistanceColor;
};
//# sourceMappingURL=i18nColorName.js.map